import script from "./TechPathDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TechPathDetail.vue?vue&type=script&setup=true&lang=js"

import "./TechPathDetail.vue?vue&type=style&index=0&id=6d8b535e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8b535e"]])

export default __exports__